import { useEffect, useState } from 'react'
import axios from 'axios'
import { Pagination, Tooltip } from 'antd'
import MyIcon from '../../components/general/icon'
import JobFairApplicationRibbon from './ribbon'
import DeleteJobFairApplication from './delete'
import JobFairApplicationDetail from './detail'
import FilterJobFairApplication from './filter'

export default function JobFairApplication() {
    const [currentPage, setCurrentPage] = useState(1)
    const [propsData, setPropsData] = useState({})
    const [applicationData, setApplicationData] = useState({})
    const [isDeleteVisible, setIsDeleteVisible] = useState(false)
    const [isDetailVisible, setIsDetailVisible] = useState(false)

    const initialConditions = {
        keywords: '',
        college: '',
        company_type: '',
        is_top_company: 0,
        audit_status: 0,
    }
    const [filterValue, setFilterValue] = useState(initialConditions)

    const getApplicationData = () => {
        axios.post('/admin/job_fair/list', {
            keywords: filterValue.keywords,
            college: filterValue.college,
            company_type: filterValue.company_type,
            is_top_company: filterValue.is_top_company,
            audit_status: filterValue.audit_status,
            page: currentPage,
            per_page: 20
        })
            .then(function (response) {
                if (response.errcode === 0) {
                    setApplicationData({
                        'total_page': response.data.total_page,
                        'current_page': response.data.current_page,
                        'total': response.data.total,
                        'list': response.data.list
                    })
                }
            })
            .catch(function (error) {
                console.error('请求失败，错误信息为：', error)
            })
    }

    useEffect(() => {
        getApplicationData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, filterValue])

    const AUDIT_STATUS = {
        1: { label: '待审', color: 'black' },
        2: { label: '审核通过', color: 'green' },
        3: { label: '审核未通过', color: 'red' }
    }

    const previewDetail = (id) => {
        setIsDetailVisible(true)
        setPropsData({ id: id })
    }

    const deleteApplication = (id, name) => {
        setIsDeleteVisible(true)
        setPropsData({ id: id, name: name })
    }

    const CAMPUS_MAP = {
        1: '兰州职业技术学院',
        2: '雁儿湾校区',
        3: '桃林校区'
    }

    return (
        <div className="public-page">
            <div className="public-container">
                <div className="public-header">
                    <div className="public-title">双选会预约申请</div>
                    <JobFairApplicationRibbon filterValue={filterValue} setFilterValue={setFilterValue} />
                </div>

                <FilterJobFairApplication filterValue={filterValue} setFilterValue={setFilterValue} setCurrentPage={setCurrentPage} />

                <div className='public-main-style2'>
                    <table className='public-main-style2-item'>
                        <thead>
                            <tr className='public-main-style2-thead'>
                                <th style={{ textAlign: 'left', paddingLeft: '20px' }}>企业名称</th>
                                <th>预约信息</th>
                                <th>审核状态</th>
                                <th>申请时间</th>
                                <th style={{ width: '50px' }}></th>
                            </tr>
                        </thead>

                        <tbody>
                            {applicationData.list && (applicationData.list.length > 0 ? (applicationData.list.map((item) => (
                                <tr className='public-main-style2-tbody' key={item.id} onClick={() => { previewDetail(item.id) }}>
                                    <td style={{ textAlign: 'left', paddingLeft: '20px' }}>{item.company_name}</td>
                                    <td>{CAMPUS_MAP[item.campus]}｜{item.date}｜{item.venue}</td>
                                    <td style={{ color: AUDIT_STATUS[item.audit_status]?.color }}>
                                        {AUDIT_STATUS[item.audit_status]?.label || '-'}
                                    </td>
                                    <td>{item.create_time}</td>
                                    <td style={{ width: '100px' }}>
                                        <div className='public-main-style2-operation-box'>
                                            <Tooltip placement="bottom" color='#1A1B1C' title="删除">
                                                <div className='public-main-style2-operation' onClick={(event) => { event.stopPropagation(); deleteApplication(item.id, item.company_name) }}>
                                                    <MyIcon name='huishouzhan' />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </td>
                                </tr>
                            ))) : (
                                <tr className='public-main-style2-tbodyEmpty'>
                                    <td colSpan="6"><span>暂无数据</span></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className='pagination'>
                    <Pagination
                        current={currentPage}
                        total={applicationData.total}
                        pageSize={20}
                        onChange={(page) => setCurrentPage(page)}
                        showTotal={(total) => `共${total}条`}
                        showSizeChanger={false}
                        hideOnSinglePage={true}
                        showQuickJumper={true}
                    />
                </div>
            </div>

            {isDeleteVisible && <DeleteJobFairApplication
                data={propsData}
                getApplicationData={getApplicationData}
                isOpen={isDeleteVisible}
                isCancel={() => { setIsDeleteVisible(false) }}
            />}

            {isDetailVisible && <JobFairApplicationDetail
                data={propsData}
                isOpen={isDetailVisible}
                getApplicationData={getApplicationData}
                isCancel={() => { setIsDetailVisible(false) }}
            />}
        </div>
    )
}
